import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { AdminService } from '@niko-crm/ui';
import { TenantActions } from './tenant.actions';
import { extractError } from '../helpers/error-reader';

@Injectable()
export class TenantEffects {
  private readonly actions$ = inject(Actions);
  private readonly adminService = inject(AdminService);

  loadTenants$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TenantActions.loadTenants),
      switchMap(({ page, limit }) =>
        this.adminService.getTenants(page, limit).pipe(
          map((result) => TenantActions.loadTenantsSuccess({ result })),
          catchError((err) =>
            of(TenantActions.loadTenantsFailure({ error: extractError(err) }))
          )
        )
      )
    )
  );

  loadActiveTenants$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TenantActions.loadActiveTenants),
      switchMap(() =>
        this.adminService.getActiveTenants().pipe(
          map((tenants) => TenantActions.loadActiveTenantsSuccess({ tenants })),
          catchError((err) =>
            of(TenantActions.loadActiveTenantsFailure({ error: extractError(err) }))
          )
        )
      )
    )
  );

  createTenant$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TenantActions.createTenant),
      switchMap(({ payload }) =>
        this.adminService.createTenant(payload).pipe(
          map((tenant) => TenantActions.createTenantSuccess({ tenant })),
          catchError((err) =>
            of(TenantActions.createTenantFailure({ error: extractError(err) }))
          )
        )
      )
    )
  );

  updateTenant$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TenantActions.updateTenant),
      switchMap(({ id, payload }) =>
        this.adminService.updateTenant(id, payload).pipe(
          map((tenant) => TenantActions.updateTenantSuccess({ tenant })),
          catchError((err) =>
            of(TenantActions.updateTenantFailure({ error: extractError(err) }))
          )
        )
      )
    )
  );

  deactivateTenant$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TenantActions.deactivateTenant),
      switchMap(({ id }) =>
        this.adminService.updateTenant(id, { active: false }).pipe(
          map(() => TenantActions.deactivateTenantSuccess({ id })),
          catchError((err) =>
            of(TenantActions.deactivateTenantFailure({ error: extractError(err) }))
          )
        )
      )
    )
  );
}
